import type { ReactElement } from 'react';
import { PortalDsBadge, type PortalDsBadgeVariant } from 'src/components/portal-design-system';
import type { FeedbackUserType } from 'src/redux/survey/survey.types';

interface ResponseSourceBadgeProps {
  userType: FeedbackUserType;
}

function badgeVariant(userType: FeedbackUserType): PortalDsBadgeVariant {
  if (userType === 'ai') {
    return 'blue';
  }
  if (userType === 'rtr') {
    return 'green';
  }
  return 'amber';
}

function ResponseSourceBadge({ userType }: ResponseSourceBadgeProps): ReactElement {
  const label = userType === 'ai' ? 'AI' : userType === 'rtr' ? 'RTR' : 'Human';

  return (
    <PortalDsBadge variant={badgeVariant(userType)}>
      {label}
    </PortalDsBadge>
  );
}

export default ResponseSourceBadge;
